var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414651",
    d: "M14.673 12.925a21.353 21.353 0 0 1-4.08 3.88 1 1 0 0 1-1.59-.881 51.714 51.714 0 0 0 0-7.848 1 1 0 0 1 1.59-.881 21.354 21.354 0 0 1 4.08 3.88 1.472 1.472 0 0 1 0 1.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronChevronRight);
export default __webpack_public_path__ + "static/media/chevron_chevron-right.22f1fc2239f88d59d6d24e0e9eef2718.svg";
export { ForwardRef as ReactComponent };